import { useState } from 'react';
import BotEpic from './BotEpic';
import logepic1 from '../assets/logepic1.jpeg';
import logepic from '../assets/logepic.jpeg';

const AvatarBot = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false); // 👈 Nuevo

  const toggleBot = () => setOpen(!open);

  return (
    <div className="relative flex flex-col items-center md:items-start">
      {/* Avatar visible */}
      <div
        className="bg-black p-2 rounded-full shadow-md border border-yellow-400 cursor-pointer hover:scale-105 transition"
        onClick={toggleBot}
        title="¡Preguntame sobre cine!"
      >
        <img
          src={loading ? logepic1 : logepic}
          alt="Bot EpicMovie"
          className="w-16 h-16 rounded-full"
        />
      </div>

      <p className="mt-2 text-center text-sm text-gray-300">
        ¿Queres saber sobre el cine?
      </p>

      {/* Chat emergente */}
      {open && (
        <div className="absolute bottom-40 left-0 z-50 ">
          <BotEpic onClose={toggleBot} setLoading={setLoading} />
        </div>
      )}
    </div>
  );
};

export default AvatarBot;
